import { matchesAirror, NO_PERMISSION, NO_WORKSPACE_PERMISSION, NOT_FOUND } from '@air/errors';

/**
 * Deleted or hidden boards are ordinary history and settle on the id fallback quietly; anything
 * else gets a retry so a transient blip doesn't look like a deleted board.
 */
export const isWorkspaceAgentPillBoardUnresolvableError = (error: unknown): boolean =>
  matchesAirror(error, NOT_FOUND) ||
  matchesAirror(error, NO_PERMISSION) ||
  matchesAirror(error, NO_WORKSPACE_PERMISSION);
